import React, { useContext } from 'react'
import { DashboardContext } from 'components/DashboardContext'
import moment from 'moment'
import { StyledPicker, StyledPickerWrapper } from './styled'
import { CalendarIconBlack, ArrowDownBranch, ArrowDownTopCombinationMini, ArrowDownTopCombination, CalendarIconTopCombination } from 'media/icons'
import { useTranslation } from 'react-i18next'
import { getPage } from 'helpers/getPage'

export const dateFormat = 'DD.MM.YYYY'

const Picker = (prop) => {
	const { formatedDate: fd, currentDate,
		setCalendarVisible, calendarVisible,
		btnText = 'Show:', pickerColor,
		pickerType = 'date', activeBranch,
		pickerStyle } = prop
	const dateWithDay = 'dddd, DD.MM.YYYY'
	const { branchList } = useContext(DashboardContext)
	const [t] = useTranslation()
	const formatedDate = moment(currentDate).format(dateFormat)
	const formatedDateWithDay = moment(currentDate).format(dateWithDay)
	const isNowDate = formatedDate === moment(new Date()).format(dateFormat)
	const formatedActiveBranch = activeBranch ? activeBranch : 'Unbestimmt'
	const dateOutput = pickerType === 'branch'
		? formatedActiveBranch : isNowDate ? `${t('dashboard_section.today')} (${formatedDate})` : formatedDateWithDay
	const customStyles = { style: { backgroundColor: pickerColor } }

	let pickerCssStyles
	let cashRegistersQuantity
	if(pickerStyle === 'branch') {
		if(branchList && dateOutput) {
			const shopInfo = branchList.find(shop => shop.name === dateOutput)
			cashRegistersQuantity = shopInfo?.cashRegisters?.length
		}
		pickerCssStyles = {
			color: 'red',
			width: '292px',
			height: '40px',
			font_size: '16px',
			font_weight: '600',
			padding_left: '10px',
			padding_right: '15px'
		}
	}else if(pickerStyle === 'dateCalendar') {
		pickerCssStyles = {
			color: '#4A90E2',
			width: isNowDate ? '227px' : '260px',
			height: '40px',
			font_size: '16px',
			font_weight: '600',
			padding_left: '0px',
			padding_right: '0px'
		}
	}else{
		//for pickerStyle === 'dateInterval' styles
		pickerCssStyles = {
			color: '#4A90E2',
			width: 'inherit',
			height: '38px',
			font_size: '16px',
			font_weight: '600',
			padding_left: '0px',
			padding_right: '0px'
		}
	}

	const page = getPage()

	let similarHeaderPages = ''

	let firstIcon = null
	if(pickerStyle === 'dateCalendar') {
		firstIcon = <CalendarIconBlack />
	}else if(page === 'top_combinations' && pickerStyle === 'dateInterval') {
		firstIcon = <CalendarIconTopCombination />
	}

	let icon
	let mainInfo = fd || dateOutput
	if(page === 'main' || page === 'branch') {
		(pickerStyle === `branch` || pickerStyle === 'dateCalendar') ? (
			icon = <ArrowDownBranch />
		) : (
			icon = <CalendarIconBlack />
		)
	}else{
		if(pickerStyle === `branch` || pickerStyle === 'dateCalendar') {
			icon = <ArrowDownTopCombinationMini className='arrow_down_mini' />
			mainInfo = <span className='main_info'>{fd || dateOutput}</span>
		}else{
			icon = <ArrowDownTopCombination />
		}
		similarHeaderPages = 'similar_header_pages'
	}

	return (
		<StyledPickerWrapper>
			{
				pickerStyle === `branch` &&
				<span>{btnText}</span>
			}
			<StyledPicker
				{...customStyles}
				onClick={() => setCalendarVisible(prevState => !prevState)}
				calendarVisible={calendarVisible}
				pickerStyle={pickerStyle}
				pickerCssStyles={pickerCssStyles}
				className={`pickerWrapper ${similarHeaderPages} ${page}_${pickerStyle}`}
			>
				<span>
					{
						firstIcon &&
					<div className='calendar_icon_first'>
						{firstIcon}
					</div>
					}
					<i className='formated_date'>
						{mainInfo}{cashRegistersQuantity && <div className='quantity'>{cashRegistersQuantity}</div>}
					</i>
				</span>
				<span className='current_date' />
				<div className='calendar_icon'>
					{icon}
				</div>
			</StyledPicker>
		</StyledPickerWrapper>
	)
}

export default Picker
